module.exports = __webpack_public_path__ + "static/foto_praktijk_2_comp-d0be0d21c21a54282ab56e859ef639a4.jpeg";